<template>
  <div class="sidebar-wrap">
    <el-menu mode="horizontal" class="sidebar-menu" style="display: flex;background-color:#0054ab" background-color="rgb(0 84 171)" text-color="#fff" active-text-color="rgb(0 49 109)" :collapse="collapse" :default-active="active" router @open="handleOpen" @close="handleClose">
      <sidebar-item v-for="(item, index) in menuList" :key="index" :item="item"></sidebar-item>
    </el-menu>
  </div>
</template>
<style  lang="scss" scoped>
.sidebar-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-menu-vertical-demo.el-menu {
  background-color: #ffffff00;
}
.el-menu.el-menu--inline {
  background-color: #ffffff00;
}
.el-menu-item,
.el-submenu__title {
  display: flex;
  align-items: center;
}
</style>
<script>

import StringTool from "@/utils/stringTool";
import SidebarItem from "./SidebarItem";
// import * as socketApi from '@common/api/index.js/webSocket.js'
export default {
  name: "Sidebar",
  components: { SidebarItem },
  props: {
    menuList: {
      type: Array,
      required: true,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      active: "",
    };
  },
  mounted () {
    this.active = StringTool.escapeUrlOfStr(this.$route.fullPath);
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath);
    },
  },
  watch: {
    $route (to, from) {
      this.active = StringTool.escapeUrlOfStr(to.fullPath);
    },
  },
};
</script>
<style scoped>
.sidebar-wrap >>> .el-menu.el-menu--horizontal {
  justify-content: space-between;
}
.sidebar-wrap >>> .el-submenu__title:active,
.sidebar-wrap >>> .el-submenu__title {
  border: none !important;
  background: none !important;
}
.sidebar-wrap >>> .el-submenu.is-active:active,
.sidebar-wrap >>> .el-submenu:active {
  border: none !important;
  background: none !important;
}
</style>
<style lang="scss">
.menu-item:focus {
  outline: none;
}
.el-submenu__title:focus,
.el-submenu__title:hover {
  background: none\0;
}
ul.el-menu.el-menu--popup.el-menu--popup-bottom-start {
  background: #0054ab !important;
}
.sidebar-menu.el-menu--horizontal.el-menu {
  .el-menu-item {
    background-color: #0054ab;
  }
  .theme-defalt .el-menu-item {
    background-color: #0054ab !important;
  }
}
.menu-item .el-submenu .el-submenu__title {
  background-color: #0054ab !important;
}
</style>
